/* Sweet Tooth — theme.js */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => window.Shopify && window.Shopify.formatMoney
    ? window.Shopify.formatMoney(cents, window.moneyFormat)
    : '₹' + (cents / 100).toFixed(0);

  /* ---------- Header scroll ---------- */
  const header = $('.header-wrap');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Overlay + drawers ---------- */
  const overlay = $('#Overlay');
  const openEl = (el) => { if (!el) return; el.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const closeAll = () => {
    $$('.drawer, .mobile-nav').forEach((d) => d.classList.remove('is-open'));
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-nav-open]');
    const cart = e.target.closest('[data-cart-open]');
    const search = e.target.closest('[data-search-open]');
    const close = e.target.closest('[data-drawer-close]');
    if (nav) { e.preventDefault(); openEl($('#MobileNav')); }
    if (cart) { e.preventDefault(); openEl($('#CartDrawer')); }
    if (search) { e.preventDefault(); openEl($('#SearchDrawer')); const i = $('#SearchInput'); if (i) setTimeout(() => i.focus(), 300); }
    if (close) { e.preventDefault(); closeAll(); }
  });

  /* ---------- Generic slider (hero + testimonials) ---------- */
  function initFader(root, opts) {
    const slides = $$(opts.slide, root);
    const dots = $$(opts.dot, root);
    if (slides.length < 1) return;
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); restart(); }));
    const restart = () => { if (!opts.autoplay || slides.length < 2) return; clearInterval(timer); timer = setInterval(() => go(i + 1), opts.interval || 5000); };
    go(0); restart();
  }
  $$('[data-hero]').forEach((h) => initFader(h, { slide: '.hero__slide', dot: '.hero__dots button', autoplay: h.dataset.autoplay === 'true', interval: parseInt(h.dataset.interval || '5', 10) * 1000 }));
  $$('[data-testimonials]').forEach((h) => initFader(h, { slide: '.testimonial', dot: '.testimonial-dots button', autoplay: true, interval: 6000 }));

  /* ---------- Accordions ---------- */
  document.addEventListener('click', (e) => {
    const trg = e.target.closest('.accordion__trigger');
    if (!trg) return;
    const panel = trg.nextElementSibling;
    const open = trg.getAttribute('aria-expanded') === 'true';
    trg.setAttribute('aria-expanded', String(!open));
    panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
  });

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
  }, { threshold: 0.12 }) : null;
  const observeReveals = () => $$('.reveal:not(.is-visible)').forEach((el) => io ? io.observe(el) : el.classList.add('is-visible'));
  observeReveals();

  /* ---------- Wishlist (localStorage) ---------- */
  const WISH_KEY = 'st_wishlist';
  const getWish = () => JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
  const setWish = (a) => localStorage.setItem(WISH_KEY, JSON.stringify(a));
  const refreshWish = () => { const w = getWish(); $$('[data-wishlist]').forEach((b) => b.classList.toggle('is-active', w.includes(b.dataset.wishlist))); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    const id = b.dataset.wishlist; let w = getWish();
    w = w.includes(id) ? w.filter((x) => x !== id) : [...w, id];
    setWish(w); refreshWish();
  });
  refreshWish();

  /* ---------- Cart ---------- */
  async function fetchCart() {
    const r = await fetch(window.routes.cart_url + '.js');
    return r.json();
  }
  function updateCartCount(count) {
    $$('.js-cart-count').forEach((el) => { el.textContent = count; el.style.display = count > 0 ? '' : 'none'; });
  }
  async function renderCart() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    const body = $('#CartDrawerBody');
    const foot = $('#CartDrawerFoot');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="btn" data-drawer-close href="' + (window.routes.all || '/collections/all') + '">Start Shopping</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map((it) => `
      <div class="cart-item" data-key="${it.key}">
        <div class="cart-item__img"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : ''}" alt="${it.product_title}" loading="lazy"></div>
        <div>
          <p class="cart-item__title">${it.product_title}</p>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${it.variant_title}</div>` : ''}
          <div class="qty">
            <button type="button" data-cart-minus aria-label="Decrease">&minus;</button>
            <input type="text" value="${it.quantity}" data-cart-qty inputmode="numeric" aria-label="Quantity">
            <button type="button" data-cart-plus aria-label="Increase">+</button>
          </div>
          <button type="button" class="cart-item__remove" data-cart-remove>Remove</button>
        </div>
        <div class="price">${money(it.final_line_price)}</div>
      </div>`).join('');
    const sub = $('#CartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
  }
  window.stRenderCart = renderCart;

  async function changeItem(key, quantity) {
    const r = await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await r.json();
    renderCart();
  }
  document.addEventListener('click', (e) => {
    const row = e.target.closest('.cart-item'); if (!row) return;
    const key = row.dataset.key; const input = $('[data-cart-qty]', row);
    if (e.target.closest('[data-cart-remove]')) changeItem(key, 0);
    if (e.target.closest('[data-cart-plus]')) changeItem(key, parseInt(input.value, 10) + 1);
    if (e.target.closest('[data-cart-minus]')) changeItem(key, Math.max(0, parseInt(input.value, 10) - 1));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-item [data-cart-qty]');
    if (input) changeItem(input.closest('.cart-item').dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* Add to cart (form + quick add) */
  async function addToCart(form, opts) {
    opts = opts || {};
    const btn = form.querySelector('[type="submit"], [data-add]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    try {
      const fd = new FormData(form);
      const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await r.json();
      if (data.status) throw new Error(data.description || 'Error');
      if (opts.checkout) { window.location.href = '/checkout'; return; }
      await renderCart();
      if (opts.openDrawer !== false) openEl($('#CartDrawer'));
    } catch (err) {
      alert(err.message || window.cartStrings.error);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const isCheckout = e.submitter && e.submitter.name === 'checkout';
    addToCart(form, { checkout: isCheckout });
  });
  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    const id = qa.dataset.quickAdd;
    const tmp = document.createElement('form');
    tmp.innerHTML = `<input name="id" value="${id}"><input name="quantity" value="1">`;
    addToCart(tmp, {});
  });

  /* Buy now */
  document.addEventListener('click', (e) => {
    const bn = e.target.closest('[data-buy-now]');
    if (!bn) return;
    const form = bn.closest('[data-product-form]');
    if (form) { form.querySelector('[name="checkout"]').click(); }
  });

  /* ---------- Product page ---------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    const variantsData = JSON.parse(($('#VariantsJSON') || {}).textContent || '[]');
    const optionInputs = () => $$('.js-option', productForm);
    function currentVariant() {
      const chosen = optionInputs().filter((i) => i.checked || i.type !== 'radio').map((i) => i.value);
      const selected = [];
      const groups = {};
      optionInputs().forEach((i) => { if (i.type !== 'radio' || i.checked) groups[i.name] = i.value; });
      const values = Object.values(groups);
      return variantsData.find((v) => v.options.every((o, idx) => o === values[idx]));
    }
    function updateVariant() {
      const v = currentVariant();
      if (!v) return;
      const idInput = $('[name="id"]', productForm); if (idInput) idInput.value = v.id;
      const priceEl = $('#ProductPrice');
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <span class="compare">${money(v.compare_at_price)}</span>` : '');
      }
      const stickyPrice = $('#StickyPrice'); if (stickyPrice) stickyPrice.textContent = money(v.price);
      const btn = $('[data-add]', productForm);
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      if (v.featured_image && v.featured_image.src) selectImage(v.featured_image.src);
    }
    optionInputs().forEach((i) => i.addEventListener('change', updateVariant));

    const mainImg = $('#ProductMainImg');
    function selectImage(src) {
      if (!mainImg) return;
      mainImg.src = src;
      $$('.product__thumbs button').forEach((b) => b.classList.toggle('is-active', b.dataset.src === src));
    }
    $$('.product__thumbs button').forEach((b) => b.addEventListener('click', () => selectImage(b.dataset.src)));

    /* Quantity */
    $$('[data-qty-btn]', productForm).forEach((b) => b.addEventListener('click', () => {
      const input = $('[name="quantity"]', productForm);
      let val = parseInt(input.value, 10) || 1;
      val = b.dataset.qtyBtn === 'plus' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    }));

    /* Sticky ATC visibility */
    const sticky = $('.sticky-atc');
    if (sticky && io) {
      const atc = $('.product__buttons');
      if (atc) {
        const obs = new IntersectionObserver((en) => { sticky.style.transform = en[0].isIntersecting ? 'translateY(100%)' : 'translateY(0)'; }, { threshold: 0 });
        obs.observe(atc);
      }
    }
    updateVariant();
  }

  /* ---------- Predictive search ---------- */
  const searchInput = $('#SearchInput');
  if (searchInput) {
    let t;
    const results = $('#SearchResults');
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6`;
          const r = await fetch(url);
          const data = await r.json();
          renderSearch(data);
        } catch (e) { /* graceful */ }
      }, 280);
    });
    function renderSearch(data) {
      const parts = [];
      const p = data.resources.results.products || [];
      const c = data.resources.results.collections || [];
      const pg = data.resources.results.pages || [];
      if (p.length) {
        parts.push('<div class="search-section-label">Products</div>');
        p.forEach((it) => parts.push(`<a class="search-result" href="${it.url}"><img src="${it.featured_image ? it.featured_image.url : ''}" alt=""><div><div class="search-result__title">${it.title}</div><div class="search-result__price">${it.price ? money(it.price) : ''}</div></div></a>`));
      }
      if (c.length) { parts.push('<div class="search-section-label">Collections</div>'); c.forEach((it) => parts.push(`<a class="search-result" href="${it.url}"><div class="search-result__title">${it.title}</div></a>`)); }
      if (pg.length) { parts.push('<div class="search-section-label">Pages</div>'); pg.forEach((it) => parts.push(`<a class="search-result" href="${it.url}"><div class="search-result__title">${it.title}</div></a>`)); }
      results.innerHTML = parts.length ? parts.join('') : '<p style="padding:12px;color:var(--color-secondary)">No results found.</p>';
    }
  }

  /* Initial cart render for counts */
  fetchCart().then((c) => updateCartCount(c.item_count)).catch(() => {});
})();
